import isString from 'lodash/isString';
import isArray from 'lodash/isArray';

/**
 * [transformDisplayValue] takes in an array as the first arg and an object with display/value keys as second arg
 * and returns an array of display/value objects
 * @param arr { [{}] } (eg. [{name: 'US Dollars', isoCode: 'USD', id: 1}, ...]
 * @param display { string } (eg. 'name')
 * @param value { string } (eg. 'isoCode')
 * @return returns an array of display/value objects (eg. [{display: 'US Dollars', value: 'USD'}, ...]
 */
export const transformDisplayValue = (arr, { display, value }) => {
  if (!isArray(arr)) {
    throw new Error('First argument must be an array');
  }

  if (!isString(display)) {
    throw new Error('Display must be a string value');
  }

  if (!isString(value)) {
    throw new Error('Value must be a string value');
  }

  return arr.map((a) => ({ display: a?.[display] || '', value: a?.[value] || '' }));
};
